export default __webpack_public_path__ + "static/media/cert-startup-HKIRC.4d37af84.jpg";